import { render } from "./OrderItem.vue?vue&type=template&id=61244a86&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"

import "./OrderItem.vue?vue&type=style&index=0&id=61244a86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61244a86"

export default script